import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ReactMarkdown from 'react-markdown';
import { toast } from 'sonner';
import { publicFetch, apiFetch } from '../lib/api';
import { defaultFAQ } from './AppDataDefaultValues.jsx';

type Form = { markdownfaq: string };

export default function AppDataPage() {
  const { register, handleSubmit, setValue, watch } = useForm<Form>({
    defaultValues: { markdownfaq: defaultFAQ },
  });

  const md = watch('markdownfaq');

  useEffect(() => {
    publicFetch('/appdata/FAQ')
      .then((res) => {
        if (!res.ok) throw new Error(String(res.status));
        return res.json();
      })
      .then((response: { markdown?: string }) => {
        if (response?.markdown) setValue('markdownfaq', response.markdown);
      })
      .catch(() => {});
  }, [setValue]);

  async function onSubmit(data: Form) {
    try {
      const res = await apiFetch('/appdata/FAQ', {
        method: 'POST',
        body: JSON.stringify({ markdown: data.markdownfaq }),
      });
      if (!res.ok) throw new Error(await res.text());
      await res.json();
      toast.success('FAQ updated (cache may take a moment).');
    } catch (e) {
      toast.error(String(e));
    }
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-ink">App data — FAQ</h1>
        <p className="text-sm text-ink-muted">
          Public read; admin write to{' '}
          <code className="rounded bg-slate-100 px-1 text-xs">POST /appdata/FAQ</code>.
        </p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="grid gap-6 lg:grid-cols-2">
        <div>
          <label className="mb-2 block text-sm font-medium">Markdown</label>
          <textarea
            {...register('markdownfaq')}
            rows={24}
            className="w-full rounded-lg border border-slate-200 font-mono text-sm"
          />
          <button
            type="submit"
            className="mt-3 rounded-lg bg-brand px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700"
          >
            Save
          </button>
        </div>
        <div>
          <p className="mb-2 text-sm font-medium">Preview</p>
          <div className="max-w-none rounded-lg border border-slate-200 bg-white p-4 text-sm leading-relaxed [&_h1]:text-xl [&_h2]:text-lg [&_p]:my-2">
            <ReactMarkdown>{md || ''}</ReactMarkdown>
          </div>
        </div>
      </form>
    </div>
  );
}
